import { Account } from '../models/account';

export const poolAccountReducer = (state = new Account()): Account => state;
